import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './ButtonWithLinkGroup.module.scss'
import Button from '../ui/buttons/button/Button'
import GetBambooButton from '../ui/buttons/custom/get-bamboo-button/GetBambooButton'
import LinkButton from '../ui/buttons/link-button/LinkButton'
import LinkWithIcon from '../ui/buttons/link-with-icon/LinkWithIcon'
import { SvgChevron } from '../ui/svg-icons'

function ButtonWithLinkGroup({
  className,
  outline,
  handleButtonPress = () => {},
  getBambooButton,
  buttonText,
  linkButtonPath,
  linkText,
  linkPath = '/',
  isExternal,
  shadowed,
  isTargetBlank,
  ...rest
}) {
  return getBambooButton || buttonText || linkText ? (
    <div className={classNames(styles.wrapper, className)} {...rest}>
      {getBambooButton ? (
        <GetBambooButton />
      ) : (
        buttonText &&
        (linkButtonPath ? (
          <LinkButton
            shadowed={shadowed}
            outline={outline}
            href={linkButtonPath}
            target={isTargetBlank && '_blank'}
            rel={isTargetBlank && 'noopener noreferrer'}
          >
            {buttonText}
          </LinkButton>
        ) : (
          <Button
            shadowed={shadowed}
            outline={outline}
            onClick={handleButtonPress}
          >
            {buttonText}
          </Button>
        ))
      )}

      {linkText && (
        <LinkWithIcon
          to={linkPath}
          {...{ isExternal, isTargetBlank }}
          icon={SvgChevron}
        >
          {linkText}
        </LinkWithIcon>
      )}
    </div>
  ) : null
}

ButtonWithLinkGroup.propTypes = {
  className: PropTypes.string,
  buttonText: PropTypes.string,
  linkText: PropTypes.string,
  linkPath: PropTypes.string,
  linkButtonPath: PropTypes.string,
  isExternal: PropTypes.bool,
  isTargetBlank: PropTypes.bool,
  getBambooButton: PropTypes.bool,
  handleButtonPress: PropTypes.func,
}

export default ButtonWithLinkGroup
